import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ProjectLocationPlanCoreModel,
} from '../../models/project-location-plan-core.model';

export const ProjectLocationPlanCoreActions = createActionGroup({
  source: 'PROJECT_LOCATION_PLAN_CORE',
  events: {
    'Reset to Initial state': emptyProps(),

    'Load project location plan cores': props<{
      projectId: string
    }>(),
    'Load project location plan cores success': props<{
      cores: ProjectLocationPlanCoreModel.PlanCoreDocument[];
    }>(),
    'Load project location plan cores fail': emptyProps(),

    'Load core types': emptyProps(),
    'Load core types success': props<{
      coreTypes: ProjectLocationPlanCoreModel.API.CoreTypeResponse[];
    }>(),
    'Load core types fail': emptyProps(),

    'Set selected Core device': props<{
      selectedCore: ProjectLocationPlanCoreModel.API.CoreTypeResponse | null;
      count?: number;
    }>(),

    'Update project location plan cores': props<{
      projectId: string;
      coreIds: string[];
      changes: ProjectLocationPlanCoreModel.API.CoreSingleFieldUpdate;
    }>(),
    'Update project location plan cores success': props<{
      cores: ProjectLocationPlanCoreModel.PlanCoreDocument[];
    }>(),
    'Update project location plan cores fail': emptyProps(),

    'Load plan cores': props<{
      projectId: string;
      locationId: string;
      planId: string;
    }>(),
    'Load plan cores success': props<{
      cores: ProjectLocationPlanCoreModel.PlanCoreDocument[];
    }>(),
    'Load plan cores fail': emptyProps(),

    'Save core': props<{
      projectId: string,
      locationId: string,
      planId: string,
      coreData: ProjectLocationPlanCoreModel.API.CreatePlanCoreDto;
    }>(),
    'Save core success': props<{
      core: ProjectLocationPlanCoreModel.PlanCoreDocument;
    }>(),
    'Save core fail': emptyProps(),

    'Update plan core': props<{
      coreId: string,
      updateData: ProjectLocationPlanCoreModel.API.UpdatePlanCoreDto;
      showToast?: boolean;
    }>(),
    'Update plan core success': props<{
      core: ProjectLocationPlanCoreModel.PlanCoreDocument;
    }>(),
    'Update plan core fail': emptyProps(),

    'Copy core': props<{
      coreId: string;
    }>(),
    'Copy core success': props<{
      core: ProjectLocationPlanCoreModel.PlanCoreDocument;
    }>(),
    'Copy core fail': emptyProps(),

    'Delete core': props<{
      coreId: string;
    }>(),
    'Delete core success': props<{
      core: ProjectLocationPlanCoreModel.PlanCoreDocument;
    }>(),
    'Delete core fail': emptyProps(),

    'Bulk delete cores': props<{
      projectId: string;
      coreIds: string[];
    }>(),
    'Bulk delete cores success': props<{
      coreIds: string[];
    }>(),
    'Bulk delete cores fail': emptyProps(),

    'Bulk create cores': props<{
      projectId: string;
      cores: ProjectLocationPlanCoreModel.API.BulkCreateCoreDto[];
    }>(),
    'Bulk create cores success': props<{
      cores: ProjectLocationPlanCoreModel.PlanCoreDocument[];
    }>(),
    'Bulk create cores fail': emptyProps(),
  },
});
